import { useMemo, useState } from "react";
import { Search, X } from "lucide-react";
import { Input } from "../ui/input";
import { personMatch } from "../../lib/searchText";

// Searchable employee picker (name / iqama / phone).
export const EmpPicker = ({ employees, value, onChange, testid = "emp-picker" }) => {
  const [q, setQ] = useState("");
  const cur = employees.find((e) => e.id === value);
  const list = useMemo(() => (q.trim() ? employees.filter((e) => personMatch(e, q)) : employees).slice(0, 30), [employees, q]);
  if (cur) return (
    <div className="flex h-9 items-center justify-between rounded-md border border-blue-300 bg-blue-50 px-2 text-sm" data-testid={`${testid}-selected`}>
      <span className="truncate font-semibold">{cur.name} <span className="font-mono text-xs font-normal text-slate-500" dir="ltr">{cur.iqama_number || ""}</span></span>
      <button type="button" onClick={() => { onChange(""); setQ(""); }} className="rounded p-0.5 hover:bg-blue-100" data-testid={`${testid}-clear`}><X className="h-4 w-4" /></button>
    </div>
  );
  return (
    <div className="space-y-1">
      <div className="relative">
        <Search className="pointer-events-none absolute start-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث بالاسم أو رقم الهوية" className="h-9 ps-8" data-testid={`${testid}-search`} />
      </div>
      <div className="max-h-40 overflow-y-auto rounded-md border border-slate-200" data-testid={`${testid}-list`}>
        {list.map((e) => (
          <button key={e.id} type="button" onClick={() => onChange(e.id)} className="flex w-full items-center justify-between px-2 py-1.5 text-start text-sm hover:bg-slate-50" data-testid={`${testid}-opt-${e.id}`}>
            <span className="truncate">{e.name}</span><span className="font-mono text-[11px] text-slate-400" dir="ltr">{e.iqama_number || ""}</span>
          </button>))}
        {!list.length && <p className="p-2 text-center text-xs text-slate-400">لا توجد نتائج</p>}
      </div>
    </div>
  );
};
